import { render, staticRenderFns } from "./cmp.vue?vue&type=template&id=63f3b3f7&scoped=true&lang=pug&"
import script from "./cmp.js?vue&type=script&lang=js&"
export * from "./cmp.js?vue&type=script&lang=js&"
import style0 from "./cmp.vue?vue&type=style&index=0&id=63f3b3f7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f3b3f7",
  null
  
)

export default component.exports